<template>
    <div class="SwiperBox" :style="{width:`${imgWidth}px`,height:`${imgWidth/1.66}px`}" ref="SwiperBox"
        @mouseenter="MouseFun('移入')" @mouseleave="MouseFun('移出')">
        <!-- 图片 -->
        <div class="imgBox" :style="{left:`-${leftVal}px`,transition:`${ition}s`}">
            <div class="imgItem" :style="{width:`${imgWidth}px`,height:`${imgWidth/1.66}px`}"
                v-for="(item,index) in imgList" :key="index">
                <span class="title">{{ item .title}}</span>
                <img :src="item.url" :style="{width:`${imgWidth}px`,height:`${imgWidth/1.66}px`}" @click="jumpNotice(item)" />
            </div>
            <!-- 复制第一张放到最后,以实现无缝无线循环滚动效果 -->
            <img :src="imgList[0].url" alt="">
        </div>
        <!-- 左箭头按钮 -->
        <div class="leftBtn" @click="throttle(PrevFun)">
            <Icon type="ios-arrow-back" />
        </div>
        <!-- 右箭头按钮 -->
        <div class="rightBtn" @click="throttle(NextFun)">
            <Icon type="ios-arrow-forward" />
        </div>
        <!-- 下方指示点容器 -->
        <div class="instBox">
            <div @click="instFun(index)" v-for="(item,index) in imgList.length" :key="index"
                :class="['inst',index==imgShow?'instActv':'']">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Sliders",
    data() {
        return {
            leftVal: 0,
            flag: true,
            start: null,
            imgWidth: window.innerWidth * 0.35,
            ition: 0.6,
            imgShow: 0,
        };
    },
    props: {
        imgList: {
            type: Array,
            default: () => [],
        },
        imgWidth: {
            type: Number,
            default: 0,
        },
    },
    mounted() {
        this.奥力给();
    },
    methods: {
        MouseFun(type) {
            type == "移入" ? clearTimeout(this.start) : this.奥力给();
        },
        奥力给() {
            this.start = setInterval(() => {
                this.NextFun();
            }, 3000);
        },
        throttle(fun) {
            if (this.flag) {
                this.flag = false;
                fun();
                setTimeout(() => {
                    this.flag = true;
                }, 650);
            }
        },
        jumpNotice(item) {
            console.log(item);
            
            GMS.$http
                .get(`/portal/cms/content?guid=` + item.guid, {})
                .then((value) => {
                    if (value.status == 200) {
                        const text = value.data.datas.data.text;
                        // Check if text contains "公告挂网地址" and has a URL
                        const urlMatch = text.match(/公告挂网地址：<a href="([^"]*)"[^>]*>([^<]*)<\/a>/i);
                        if (urlMatch && urlMatch[1]) {
                            // Found a URL after "公告挂网地址", redirect to it
                            window.open(urlMatch[1], "_blank");
                        } else {
                            // No matching URL found, throw error which will trigger .catch()
                            throw new Error("No valid announcement URL found in content");
                        }
                    }
                })
                .catch((error) => {
                    this.jumpDetail(item);
                });
        },
        jumpDetail(res){
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            this.$router.push({
                                path: "/home/detail",
                                query: {
                                    title: res.title,
                                    name: "",
                                    guid: res.guid,
                                    total: res.title,
                                },
                            });
                        }
                    }
                });
        },
        PrevFun() {
            if (this.leftVal == 0) {
                this.ition = 0;
                this.imgShow = this.imgList.length - 1;
                this.leftVal = this.imgList.length * this.imgWidth;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.ition = 0.6;
                        this.leftVal -= this.imgWidth;
                    }, this.ition * 1000);
                });
            } else {
                this.ition = 0.6;
                this.leftVal -= this.imgWidth;
                this.imgShow--;
            }
        },
        NextFun() {
            if (this.leftVal == (this.imgList.length - 1) * this.imgWidth) {
                this.ition = 0.6;
                this.leftVal += this.imgWidth;
                this.imgShow = 0;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.ition = 0;
                        this.leftVal = 0;
                    }, this.ition * 1000);
                });
            } else {
                this.ition = 0.6;
                this.leftVal += this.imgWidth;
                this.imgShow++;
            }
        },
        instFun(index) {
            this.ition = 0.6;
            this.leftVal = index * this.imgWidth;
            this.imgShow = index;
        },
    },
};
</script>

<style scoped>
* {
    padding: 0px;
    margin: 0px;
    box-sizing: border-box;
}
.SwiperBox {
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
}
.imgBox {
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: flex-start;
}
.imgBox img {
    flex-shrink: 0;
}
.imgItem {
    position: relative;
}
.title {
    position: absolute;
    left: 30px;
    bottom: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
.leftBtn,
.rightBtn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(109, 109, 109, 0.445);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
    font-weight: 640;
    user-select: none;
}
.leftBtn {
    left: 10px;
}
.rightBtn {
    right: 10px;
}
.instBox {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    display: flex;
}
.inst {
    width: 10px;
    height: 10px;
    border: 1px solid #ccc;
    margin-right: 8px;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
}
.inst:last-child {
    margin-right: 0px;
}
.instActv {
    border: 1px solid #2947ac;
    background: #2947ac;
}
</style>


// WEBPACK FOOTER //
// src/components/sliders.vue